export default "__VITE_PUBLIC_ASSET__adbf29f7__"